package nl.volleyplanner.api

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class GeneratePageTokenRequest(
    val pageType: String,
    val validDurationMinutes: Long
)

@Serializable
data class PageTokenDetails(
    val tokenString: String,
    val pageType: String,
    val validUntil: LocalDateTime
)

@Serializable
data class AnonymousPageTokenResult(
    val organisationSlug: String,
    val pageType: String,
    val pageData: String
)